import { render } from "./CGUPage.vue?vue&type=template&id=4380efe6"
import script from "./CGUPage.vue?vue&type=script&lang=js"
export * from "./CGUPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Urakehn\\Documents\\Developpement\\R42\\EasyProf_landing\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__